import type { CSSProperties, ReactNode } from 'react'

export type SelectableListItem = {
  id: string
  /** Top-left primary text (e.g. claim id). */
  primary: ReactNode
  /** Bottom-left supporting text (e.g. date). */
  secondary?: ReactNode
  /** Top-right meta (e.g. amount). */
  meta?: ReactNode
  /** Bottom-right status (e.g. Badge). */
  status?: ReactNode
  disabled?: boolean
}

export type SelectableListPreviewState =
  | 'default'
  | 'selected'
  | 'hover'
  | 'no-header'
  | 'no-meta'
  | 'disabled-item'

export const SELECTABLE_LIST_PREVIEW_STATES: SelectableListPreviewState[] = [
  'default',
  'selected',
  'hover',
  'no-header',
  'no-meta',
  'disabled-item',
]

export const SELECTABLE_LIST_PREVIEW_STATE_LABELS: Record<
  SelectableListPreviewState,
  string
> = {
  default: 'Default',
  selected: 'Selected',
  hover: 'Hover',
  'no-header': 'No header',
  'no-meta': 'No title meta',
  'disabled-item': 'Disabled item',
}

export const SELECTABLE_LIST_DEMO_TITLE = 'Claim list'

export const SELECTABLE_LIST_DEMO_ITEMS: SelectableListItem[] = [
  {
    id: '1',
    primary: 'CLM-10482',
    secondary: '3/12/2026',
    meta: '$1,250.00',
    status: 'Posted',
  },
  {
    id: '2',
    primary: 'CLM-10491',
    secondary: '3/14/2026',
    meta: '$840.00',
    status: 'Pending',
  },
  {
    id: '3',
    primary: 'CLM-10502',
    secondary: '3/18/2026',
    meta: '$2,110.00',
    status: 'Processing',
  },
]

export type SelectableListProps = {
  title?: ReactNode
  /** Right-side header meta (e.g. “3 Claims”). */
  titleMeta?: ReactNode
  items?: SelectableListItem[]
  value?: string
  defaultValue?: string
  onChange?: (id: string) => void
  /** Scroll area max height. Default `342`. */
  maxHeight?: number | string
  /** Panel width. Default `250`. */
  width?: number | string
  className?: string
  style?: CSSProperties
  /** Dark surface styling (aligned with SelectionBox / SelectableCard / SectionCard). */
  darkMode?: boolean
  /** Static visual state for the design-system showcase only. */
  previewState?: SelectableListPreviewState
}
